// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#share-embed{cursor:pointer;height:3.5rem;padding:.312rem .625rem;resize:none}.copy-to-clipboard-success{display:none;vertical-align:middle;font-size:.875rem}.copy-to-clipboard-success.active{display:inline-flex;align-items:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
